export default "__VITE_ASSET__4eec399c__"